import { Component, OnInit } from '@angular/core';
import { AuthorisedSideNavService } from '../../../layout/authorised/services/authorised-side-nav.service';
import { FormBuilder,FormControl, Validators ,FormGroup,FormArray } from '@angular/forms';
import { ClientServiceService } from "../../../shared/client-service.service";
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  loggedInUserForm: FormGroup;
  nonLoggedInUserForm: FormGroup;
  userData:any;

  submittingForm: boolean = false;
  formSubmitted: boolean = false;
  formResult: boolean = false;
  formResultMessage: string = '';
  submitClicked: boolean = false;

  constructor(
    public sideNavService: AuthorisedSideNavService, 
    private formBuilder: FormBuilder, 
    public restApi: ClientServiceService, 
    private route: ActivatedRoute,
    public authService: AuthService,
  ) { }

  ngOnInit(): void 
  {
    
    this.loggedInUserForm = new FormGroup(
    {
      token: new FormControl('', Validators.required),
      old_password: new FormControl('', Validators.required),
      new_password: new FormControl('', Validators.required),
      retype_new_password: new FormControl('', Validators.required)
    });

    this.nonLoggedInUserForm = new FormGroup(
    {
      token: new FormControl('', Validators.required),
      new_password: new FormControl('', Validators.required),
      retype_new_password: new FormControl('', Validators.required)
    });

    if(this.authService.isLoggedIn())
    {
      let userDataString = localStorage.getItem('seocurrentUser');
      let userData = JSON.parse(userDataString);
      console.log('userData', userData);
      this.loggedInUserForm.controls['token'].setValue(userData.token);
    }
    else
    {
      this.route.paramMap.subscribe(params => 
      {
        if (params.get('token'))
        {
          let token = params.get('token');
          this.nonLoggedInUserForm.controls['token'].setValue(token);
        }
      });
    }
  }
 
  submitForm(): void 
  {
    this.submitClicked = true;

    if (this.authService.isLoggedIn())
    {
      if (this.loggedInUserForm.valid) 
      {
        this.submittingForm = true;
        this.restApi.SubmitPasswordForm(this.loggedInUserForm.value).subscribe(data =>
        {
          this.submitClicked = false;
          this.submittingForm = false;

          this.formSubmitted = true;
          this.formResult = data.success;
          this.formResultMessage = data.message;

          if (this.formResult)
          {
            this.loggedInUserForm.controls['old_password'].setValue('');
            this.loggedInUserForm.controls['new_password'].setValue('');
            this.loggedInUserForm.controls['retype_new_password'].setValue('');
          } 
       });
      }
    }
    else
    {
      if (this.nonLoggedInUserForm.valid) 
      {
        this.submittingForm = true;
        this.restApi.SubmitPasswordForm(this.nonLoggedInUserForm.value).subscribe(data =>
        {
          this.submitClicked = false;
          this.submittingForm = false;

          this.formSubmitted = true;
          this.formResult = data.success;
          this.formResultMessage = data.message;

          if (this.formResult)
          {
            this.nonLoggedInUserForm.controls['new_password'].setValue('');
            this.nonLoggedInUserForm.controls['retype_new_password'].setValue('');
          } 
       });
      }
    }
  }

}
